import { callerCreator } from "../callerCreator";
import { socialAuthSlice } from "./socialAuthSlice";

export default callerCreator(socialAuthSlice.actions);
